import { ContainerProps, Container as MuiContainer } from "@mui/material";

type Props = ContainerProps;

export const Container = ({ children, ...props }: Props) => {
  return <MuiContainer {...props}>{children}</MuiContainer>;
};
